import { Check } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";
import { useLang } from "../../i18n";

export const Sustainability = () => {
  const { t } = useLang();
  const checks = [t("sus.c1"), t("sus.c2"), t("sus.c3"), t("sus.c4")];
  return (
    <section id="sostenibilita" data-testid="sustainability-section" className="bg-[#F3EFE6] py-24 lg:py-40">
      <div className="max-w-[1400px] mx-auto px-6 sm:px-12 lg:px-20 grid lg:grid-cols-12 gap-12 lg:gap-20 items-center">
        <div className="lg:col-span-6">
          <Reveal><Eyebrow>{t("sus.eyebrow")}</Eyebrow></Reveal>
          <Reveal delay={0.1}>
            <h2 className="mt-6 font-serif font-light text-4xl sm:text-5xl lg:text-6xl leading-[1.02] tracking-tight text-[#1C1917]">
              {t("sus.h2a")} <em className="text-[#6B7A63]">{t("sus.h2em")}</em>{t("sus.h2b")}
            </h2>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="mt-8 text-base md:text-lg text-[#57534E] leading-relaxed max-w-xl">{t("sus.p")}</p>
          </Reveal>
          <ul className="mt-10 space-y-4">
            {checks.map((c, i) => (
              <Reveal key={c} delay={0.08 * i} y={20}>
                <li className="flex items-center gap-4 text-[#1C1917]" data-testid={`sustainability-check-${i}`}>
                  <span className="w-8 h-8 rounded-full border border-[#6B7A63] flex items-center justify-center shrink-0">
                    <Check className="w-4 h-4 text-[#6B7A63]" />
                  </span>
                  {c}
                </li>
              </Reveal>
            ))}
          </ul>
          <Reveal delay={0.3}>
            <a href="#contatti" data-testid="sustainability-cta" className="btn-pill mt-12 bg-[#29221D] text-[#FBF9F5]">{t("sus.cta")}</a>
          </Reveal>
        </div>
        <div className="lg:col-span-6 relative">
          <Reveal>
            <div className="aspect-[4/5] overflow-hidden rounded-t-full">
              <img src="/img/knit.jpg" alt="Trama di maglia in cashmere" loading="lazy" decoding="async" className="w-full h-full object-cover hover:scale-105 transition-transform duration-[1500ms]" />
            </div>
          </Reveal>
          <div data-testid="experience-stat" className="absolute -bottom-8 left-4 sm:-left-8 bg-[#29221D] text-[#F3EFE6] p-8 sm:p-10">
            <p className="font-serif text-6xl sm:text-7xl leading-none">30<span className="text-[#C18A53]">+</span></p>
            <p className="mt-3 font-mono text-xs uppercase tracking-[0.2em] text-[#E2C9A6]">{t("sus.years")}</p>
          </div>
        </div>
      </div>
    </section>
  );
};
